import { render } from "./RouteSelectorButton.vue?vue&type=template&id=1bec018c&scoped=true"
import script from "./RouteSelectorButton.vue?vue&type=script&lang=js"
export * from "./RouteSelectorButton.vue?vue&type=script&lang=js"

import "./RouteSelectorButton.vue?vue&type=style&index=0&id=1bec018c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bec018c"]])

export default __exports__